{
  "title": "Mandanten",
  "subtitle": "Alle Kundenorganisationen auf der Plattform",
  "subtitlePartnerView": "Diesem Partner zugeordnete Kunden",
  "addTenant": "Mandanten hinzufügen",
  "onlyMspCanAdd": "Nur MSP-Administratoren können Mandanten hinzufügen",
  "cannotAddTenant": "Zum Hinzufügen eines Mandanten brauchen Sie MSP- oder Partner-Administratorrechte",
  "loadError": "Mandanten konnten nicht geladen werden",
  "emptyTitle": "Noch keine Mandanten",
  "emptyDescription": "Ein Mandant ist eine Kundenorganisation. Das Anlegen startet den Onboarding-Assistenten: Einwilligung, Connectoren, Pilotgruppe und Validierung, bevor deren E-Mail angefasst wird.",
  "emptyTitlePartnerView": "Noch keine Kunden für diesen Partner",
  "emptyDescriptionPartnerView": "Fügen Sie einen Kunden hinzu, um das Onboarding zu starten. Neue Mandanten werden diesem Partner automatisch zugeordnet.",
  "colTenant": "Mandant",
  "colOnboarding": "Onboarding",
  "colStamping": "Stempelung",
  "colDomains": "Domänen",
  "colSnapshot": "Snapshot",
  "noneSynced": "keine synchronisiert",
  "orgName": "Organisationsname",
  "orgNamePlaceholder": "Contoso GmbH",
  "slug": "Slug",
  "slugDescription": "Kleinbuchstaben; wird in URLs und im Zertifikats-Subject des Mandanten verwendet. Nach Start des Onboardings nicht änderbar.",
  "slugError": "Nur Kleinbuchstaben, Ziffern und Bindestriche.",
  "createError": "Mandant konnte nicht erstellt werden",
  "onboardingStateCreated": "Erstellt",
  "onboardingStateConsented": "Einwilligung erteilt",
  "onboardingStateConnectors": "Connectoren erstellt",
  "onboardingStatePilot": "Pilot",
  "onboardingStateValidated": "Validiert",
  "onboardingStateOrgWide": "Organisationsweit",
  "onboardingStateOffboarding": "Offboarding",
  "stampingActive": "Aktiv",
  "stampingActivePilot": "Aktiv (Pilot)",
  "stampingBypassed": "Umgangen",
  "stampingBypassedAuto": "Umgangen (automatisch)",
  "noReasonRecorded": "Kein Grund erfasst",
  "overview": "Übersicht",
  "defaultFieldsTitle": "Standardfelder",
  "defaultFieldsHint": "Diese Werte füllen leere Verzeichnisfelder für alle. Gruppenfüllungen haben für Mitglieder Vorrang; eine persönliche Überschreibung gewinnt immer.",
  "defaultFieldsSaved": "Standardfelder gespeichert.",
  "tabSettings": "Einstellungen",
  "tabBilling": "Abrechnung",
  "tabAccess": "Zugriff",
  "tabDirectory": "Verzeichnis",
  "loadTenantError": "Mandant konnte nicht geladen werden",
  "deleteTenant": "Mandanten löschen",
  "deleteConfirmTitle": "Diesen Mandanten löschen?",
  "deleteConfirmBody": "Dadurch wird {{name}} aus Listen und Stempelung entfernt. Der Datensatz bleibt für Audit und Abrechnungshistorie erhalten.",
  "partner": "Partner",
  "noPartner": "Kein Partner",
  "stampingMode": "Stempelmodus",
  "bypassReason": "Grund für die Umgehung",
  "setActive": "Aktivieren",
  "setBypass": "Stempelung umgehen",
  "smartHost": "Smart Host",
  "verifiedDomains": "Verifizierte Domänen",
  "snapshotVersion": "Snapshot-Version",
  "noAccessPartners": "Kein Zugriff auf Partner",
  "noAccessPartnersBody": "Wiederverkäufervereinbarungen werden vom OnBrand-Mail-Team verwaltet.",
  "tabSignatures": "Signaturen",
  "tabRules": "Regeln",
  "tabCampaigns": "Kampagnen",
  "tabUsers": "Benutzer",
  "tenantNotFound": "Mandant nicht gefunden",
  "tenantNotFoundBody": "Dieser Mandant existiert nicht, oder Sie haben keinen Zugriff darauf.",
  "openDesigner": "Designer öffnen",
  "loadTemplatesError": "Vorlagen konnten nicht geladen werden",
  "noTemplatesTitle": "Noch keine Vorlagen",
  "noTemplatesDescription": "Entwerfen, veröffentlichen und organisieren Sie Signaturvorlagen für diesen Mandanten. Alles beginnt im Designer.",
  "templatesAssignableHint": "Vorlagen, die die Regeln dieses Mandanten zuweisen können.",
  "renderingSignaturesTitle": "Signaturen werden gerendert",
  "renderingSignaturesBody": "Eine Veröffentlichung oder Regeländerung wird auf die Postfächer dieses Mandanten angewendet. Bis sie fertig ist, behalten Absender die Signatur, die sie bereits hatten.",
  "lastRenderFailed": "Das letzte Rendering ist fehlgeschlagen",
  "retriedTimes": "{{count}}-mal erneut versucht.",
  "publishedDate": "veröffentlicht {{date}}",
  "neverPublished": "nie veröffentlicht",
  "templateStatusDraft": "Entwurf",
  "templateStatusPublished": "Veröffentlicht",
  "templateStatusArchived": "Archiviert",
  "openRulesEditor": "Regeleditor öffnen",
  "loadRulesError": "Regeln konnten nicht geladen werden",
  "noRulesTitle": "Noch keine Regeln",
  "noRulesDescription": "Ohne Standard oder Regel wird nichts gestempelt. Legen Sie unter Benutzer eine Standard-Signatur fest, oder öffnen Sie den Regeleditor für eine engere Regel.",
  "rulesEvalHint": "Von oben nach unten ausgewertet; die erste Übereinstimmung gewinnt.",
  "matchesNobody": "Trifft auf niemanden zu",
  "matchesNobodyTooltip": "Ein leerer Absenderbereich trifft auf niemanden zu, daher löst diese Regel nie aus.",
  "newWithTemplate": "Neu: {{name}}",
  "newNoTemplate": "Neu: keine Vorlage",
  "replyWithTemplate": "Antwort: {{name}}",
  "replySameAsNew": "Antwort: wie neu",
  "primaryDefault": "Primärer Standard",
  "defaultBadge": "Standard",
  "everyone": "Alle",
  "stampingStoppedAutoTitle": "Stempelung hat sich selbst gestoppt",
  "stampingBypassedTitle": "Stempelung ist umgangen",
  "stampingStoppedAutoBody": "Ein Mail-Flow-Knoten hat die Stempelung dieses Mandanten nach wiederholten Fehlern um {{when}} gestoppt. Niemand hat sie ausgeschaltet. E-Mail fließt ungestempelt.",
  "stampingBypassedBody": "E-Mail für diesen Mandanten wird unverändert weitergeleitet.",
  "stampingModeHint": "Umgehen leitet die E-Mail dieses Mandanten unberührt weiter und hält OnBrand Mail im Pfad. Nutzen Sie es, wenn Signaturen falsch sind oder der Renderpfad fehlschlägt — nicht, wenn E-Mail selbst nicht fließen kann.",
  "resumeStamping": "Stempelung fortsetzen",
  "stampingModePermission": "Mandantenadministratoren und darüber können den Stempelmodus ändern.",
  "operations": "Betrieb",
  "operationsHint": "Verbinden Sie das Kundenverzeichnis, erzeugen Sie Exchange-Connectoren und prüfen Sie hier den Mail-Pfad. Der Konfigurationstester prüft DNS, TLS und den Relay, bevor E-Mail über die Plattform geleitet wird.",
  "onboardingWizard": "Onboarding-Assistent",
  "configurationTester": "Konfigurationstester",
  "mspOperations": "MSP-Betrieb",
  "mspOperationsHint": "Snapshot-Erhöhungen zwingen Mail-Flow-Knoten, Regeln und Vorlagen neu zu laden. Das Rotieren des Stempelgeheimnisses ungültigt das vorherige — aktualisieren Sie die Transportregel des Mandanten, bevor E-Mail fortgesetzt wird.",
  "bumpSnapshot": "Snapshot erhöhen",
  "snapshotBumped": "Snapshot auf v{{version}} erhöht.",
  "bumpFailed": "Erhöhung fehlgeschlagen.",
  "rotateStampingSecret": "Stempelgeheimnis rotieren",
  "deleteTenantHint": "Entfernt diese Organisation von der Plattform. Die Stempelung stoppt sofort und der Mandant verschwindet aus jeder Liste. Entfernen Sie zuerst Exchange-Connectoren und Transportregeln, wenn E-Mail noch über OnBrand Mail fließt — das Löschen baut diese nicht ab.",
  "bypassPlaceholder": "INC-4711 Renderfehler, umgangen bis zur Untersuchung",
  "resumePlaceholder": "INC-4711 behoben; Fortsetzen nach bestandenem Canary",
  "signatureRendering": "Signatur-Rendering",
  "signatureRenderingHint": "Signaturen werden pro Postfach im Voraus gerendert, sodass das Stempeln einer Nachricht eine Suche statt eines Renderings ist. Das Veröffentlichen einer Vorlage oder Ändern einer Regel stellt dies automatisch in die Warteschlange.",
  "renderingNow": "Wird gerade gerendert",
  "queued": "In Warteschlange",
  "lastCompletedAt": "Zuletzt abgeschlossen {{when}}",
  "nothingRenderedYet": "Noch nichts gerendert",
  "rerenderQueued": "Erneutes Rendering in Warteschlange. Signaturen aktualisieren sich innerhalb weniger Sekunden.",
  "rerenderFailed": "Erneutes Rendering konnte nicht in die Warteschlange gestellt werden.",
  "rerenderSignatures": "Signaturen erneut rendern",
  "rerenderPermission": "Mandantenadministratoren und darüber können ein erneutes Rendering erzwingen.",
  "stampingBypassedToast": "Stempelung umgangen. E-Mail wird unverändert weitergeleitet.",
  "stampingResumedToast": "Stempelung fortgesetzt.",
  "reasonRequiredHint": "Ein Grund ist erforderlich. Er wird am Mandanten angezeigt und bei Incidents gelesen.",
  "updateStampingError": "Stempelmodus konnte nicht aktualisiert werden",
  "bypassConfirm": "Umgehen",
  "resumeConfirm": "Fortsetzen",
  "copySecretNowTitle": "Jetzt kopieren",
  "copySecretNowBody": "Das Geheimnis wird einmal angezeigt. Nur sein Hash wird gespeichert. Fügen Sie es in die Transportregel des Mandanten ein, bevor E-Mail wieder zugeordnet wird.",
  "copySecretButton": "Geheimnis kopieren",
  "rotateConfirmHint": "Rotieren ungültigt das vorherige Geheimnis sofort. Tippen Sie {{word}} zur Bestätigung.",
  "confirmation": "Bestätigung",
  "rotateSecretError": "Geheimnis konnte nicht rotiert werden",
  "deleteCannotUndo": "Dies kann vom Portal aus nicht rückgängig gemacht werden",
  "deleteWarningBody": "{{name}} ({{slug}}) verschwindet aus jeder Mandantenliste und wird nicht mehr gestempelt. Exchange-Connectoren und Transportregeln werden nicht automatisch entfernt.",
  "typeSlugToConfirm": "Tippen Sie {{slug}} zur Bestätigung",
  "deleteTenantError": "Mandant konnte nicht gelöscht werden",
  "tenantDeleted": "{{name}} wurde gelöscht.",
  "noRoleBody": "Sie haben keine Rolle für diesen Mandanten.",
  "readOnlyTitle": "Nur Lesen",
  "noAccessTenantTitle": "Kein Zugriff auf diesen Mandanten",
  "noAccessRulesTitle": "Kein Zugriff auf diese Regeln",
  "readOnlyRulesBody": "Sie können die Regeln sehen und den Tester ausführen, aber Änderungen erfordern die Rolle Editor.",
  "noAccessDesignerTitle": "Kein Zugriff auf diesen Designer",
  "noAccessDesignerBody": "Sie benötigen die Rolle Designer oder höher für diesen Mandanten, um dessen Signaturvorlagen zu bearbeiten.",
  "noAccessUsersTitle": "Kein Zugriff auf diese Benutzer",
  "readOnlyUsersBody": "Sie können Postfächer und Signaturen sehen, aber Überschreibungen erfordern die Rolle Mandantenadministrator.",
  "noAccessGroupsTitle": "Kein Zugriff auf diese Gruppen",
  "readOnlyGroupsBody": "Sie können synchronisierte Gruppen sehen, aber Überschreibungen erfordern die Rolle Mandantenadministrator.",
  "noAccessCampaignsTitle": "Kein Zugriff auf diese Kampagnen",
  "readOnlyCampaignsBody": "Sie können Kampagnen sehen, aber Erstellen oder Ändern erfordert die Rolle Editor."
}
